import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconBrain,
  IconRobot,
  IconChartDots,
  IconBuildingSkyscraper,
} from '@tabler/icons-react';

const cloudAdminFeatures: FeatureData[] = [
  {
    title: '',
    description: '',
    icon: <IconBrain size={24} />,
    key: 'features.cloudAdmin.feature1'
  },
  {
    title: '',
    description: '',
    icon: <IconRobot size={24} />,
    key: 'features.cloudAdmin.feature2'
  },
  {
    title: '',
    description: '',
    icon: <IconChartDots size={24} />,
    key: 'features.cloudAdmin.feature3'
  },
  {
    title: '',
    description: '',
    icon: <IconBuildingSkyscraper size={24} />,
    key: 'features.cloudAdmin.feature4'
  },
];

export default cloudAdminFeatures; 